import { Component } from 'preact'
import Button from '../../control-components/ui-components/Button'
import ImageUploader from '../../control-components/category/ImageUploader'

export interface ImageUploadFieldProps {
  src: string
  onChange: (src: string) => void
}

export default class ImageUploadField extends Component<ImageUploadFieldProps> {
  uploader: HTMLInputElement | null = null

  render () {
    return (
      <div>
        {
        this.props.src
          ? (
            <div className='image-upload-field__container'>
              <div className='image-upload-field__image-wrapper'>
                <img src={this.props.src} />
                <a
                  target='_blank' rel='noreferrer' href={this.props.src}
                  className='component-uploader__image-details'
                >
                  <i className='icon icon-external' />
                </a>
              </div>
              <div className='image-upload-field__buttons'>
                <Button
                  type='button'
                  class='btn-default btn--insided-secondary-brand'
                  onClick={() => this.uploader?.click()}
                >
                  Edit
                </Button>
                <Button
                  type='button'
                  class='btn-default btn--insided-secondary-brand btn-delete'
                  onClick={() => this.props.onChange('')}
                >
                  Remove
                </Button>
              </div>
            </div>
            )
          : (
            <div>
              <Button
                type='button'
                class='btn-default btn-primary'
                onClick={() => this.uploader?.click()}
              >
                Upload image
              </Button>
            </div>
            )
      }
        <ImageUploader
          // eslint-disable-next-line @typescript-eslint/naming-convention
          onUploaded={({ source_thumb }: { source_thumb: string }) => this.props.onChange(source_thumb)}
          uploaderRef={(ref: HTMLInputElement) => { this.uploader = ref }}
        />
      </div>
    )
  }
}
